<template>
	<div class="card card-white mx-auto max-w-2xl">
		<h1 class="text-2xl font-medium mb-8">
			{{ header }}
		</h1>

		<div class="text-sm">
			<ul class="nav-tabs mb-8">
				<li :class="{'active': part === 'users'}">
					<a href="#" @click.prevent="setPart('users', true)">
						Пользователи
					</a>
				</li>
				<li :class="{'active': part === 'channels'}">
					<a href="#" @click.prevent="setPart('channels', true)">
						Подсайты
					</a>
				</li>
			</ul>

			<div>
				<loader v-if="loading"></loader>

				<div v-else>
					<a v-for="(item, i) in items" :href="item.url"
					   class="flex space-x-4 text-black dark:text-white items-center p-3 px-4 rounded hover:bg-gray-50 dark:hover:bg-slate-800">
						<div class="w-4 text-right font-medium text-lg">
							{{ getMedalByPlace(i) }}
						</div>
						<div class="w-6 text-right font-medium">{{ i + 1 }}</div>
						<div class="w-8 h-8 rounded-full border border-gray-500 bg-cover bg-center"
							 :style="item.ava ? 'background-image: url(' + item.ava + ')': ''"
						></div>
						<div class="font-medium truncate whitespace-nowrap flex-1">
							{{ item.name }}
						</div>
						<div
							class="w-12 text-right font-medium overflow-hidden text-ellipsis"
							:class="{
								'text-green-500': item.rate > 0,
								'text-red-500': item.rate < 0,
							}"
						>
							{{ item.rate }}
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import Loader from "../partials/Loader.vue";

export default {
	props: ['selectedPart'],
	components: {Loader},
	data() {
		return {
			loading: true,
			part: this.selectedPart || 'users',
			users: [],
			channels: [],
		};
	},
	mounted() {
		this.loadRating();

		window.addEventListener("popstate", (event) => {
			if (event.state && event.state.part) {
				this.setPart(event.state.part);
			} else {
				this.setPart('users');
			}
		});
	},
	methods: {
		setPart(part, setState = false) {
			if (part !== this.part) {
				this.part = part;
				this.loadRating();

				if (setState) {
					let url = '/rating' + (this.part === 'channels' ? '/' + this.part : '');
					window.history.pushState({part: this.part}, null, url);
				}
			}
		},
		loadRating() {
			if (this.items.length) {
				return;
			}

			Client.get('/api/v1.1/rating/' + this.part)
				.then(response => {
					this[this.part] = response.data.data;
				})
				.catch(error => {
					notify({
						text: '',
						type: 'error',
					})
				})
				.finally(() => this.loading = false);
		},
		getMedalByPlace(i) {
			if (i === 0) {
				return '🥇';
			}
			if (i === 1) {
				return '🥈';
			}
			if (i === 2) {
				return '🥉';
			}
		}
	},
	computed: {
		header() {
			return this.part === 'users' ? 'Рейтинг пользователей' : 'Рейтинг подсайтов';
		},
		items() {
			return this.part === 'users' ? this.users : this.channels;
		}
	},
}
</script>
